import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from '../../../components/I18n';
import UIImage from 'UIComponents/image/UIImage';
import { H4 } from 'UIComponents/elements/headings'; // @ts-expect-error Could not find a declaration file for module

import abstractCardImage from 'bender-url!../../../../images/content-empty-icon.svg';
import UISection from 'UIComponents/section/UISection';
import styled from 'styled-components';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { device } from '../../../constants/StyledComponentConstants';
const MediaWrapper = styled(UIMediaObject).withConfig({
  displayName: "SavedItemsEmpty__MediaWrapper",
  componentId: "sc-5t36nv-0"
})(["@media screen and ", "{max-width:550px;margin:80px auto 0 auto;}img{margin-left:38px;}@media screen and ", "{flex-direction:column !important;margin:22px;text-align:center;justify-items:center;img{display:inline;margin-left:0;}}"], device.not.mobile, device.mobile);
export const SavedItemsEmpty = ({
  itemKey
}) => {
  return /*#__PURE__*/_jsx(UISection, {
    "data-test-id": `${itemKey}-empty`,
    children: /*#__PURE__*/_jsxs(MediaWrapper, {
      itemRight: /*#__PURE__*/_jsx(UIImage, {
        src: abstractCardImage
      }),
      children: [/*#__PURE__*/_jsx(H4, {
        role: "presentation",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.savedItems.${itemKey}.emptyHeading`
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "m-right-5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.savedItems.${itemKey}.emptyBody`
        })
      })]
    })
  });
};
export default SavedItemsEmpty;